import React from 'react';
import {
  Modal,
  ModalVariants,
  Typography,
  List,
  ListVariant,
  TypographyVariant,
  Button as RPLButton,
} from '@hid-galaxy-ui/galaxy-react';

import styles from './LoginFlowModal.module.scss';
import { useHistory } from 'react-router-dom';
import buildPATHS from '../../utils/paths';
import { setSessionStorageItem } from '../../utils/sessionUtils';
import Button from '../Button/Button';
import { continueAsGuestSelector, createAccountEnabledSelector, loginEnabledSelector } from '../../store/selectors/formSessionSelectors';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const LoginFlowModal = (props: { onClose: () => void }) => {
  const { onClose } = props;
  const history = useHistory();
  const PATHS = buildPATHS();
  const continueAsGuest = useSelector(continueAsGuestSelector);
  const loginEnabled = useSelector(loginEnabledSelector);
  const createAccountEnabled = useSelector(createAccountEnabledSelector);
  const { t } = useTranslation();

  const handleLoginClick = () => {
    setSessionStorageItem('isLoginFlowModalClosed', true);
    history.push(PATHS.login);
  };

  const handleGuestClick = () => {
    setSessionStorageItem('isLoginFlowModalClosed', true);
    onClose();
  };

  const handleRegisterClick = () => {
    setSessionStorageItem('isLoginFlowModalClosed', true);
    history.push(PATHS.account_register);
  };

  return (
    <Modal
      size={ModalVariants.Medium}
      headerText={'Confirmation'}
      isDisplayCloseIcon={false}
      className="hid-modal__custom-footer"
    >
      <div className="hid-flex hid-flex-column">
        <Typography variant={TypographyVariant.H2}>
          {t('TO_PROCEED_MSG') as string}
        </Typography>
        <div className="hid-layout__m-05">
          <List
            mode={ListVariant.OrderedList}
            id="List"
            data={[
              ...(loginEnabled ? [{ key: '1', title: t('LOGIN_MSG1'), subList: [] }] : []),
              ...(createAccountEnabled ? [{ key: '2', title: t('REGISTER_TO_CREATE_NEW_ACCOUNT'), subList: [] }] : []),
              ...(continueAsGuest ? [{
                key: '3',
                title: t('CONTINUE_AS_GUEST_MSG'),
                subList: [],
              }] : []),
            ]}
          />
        </div>
      </div>

      <footer className={cx("hid-flex hid-flex-row hid-text-center hid-layout__pl-0", {
        "hid-flex-jc-end": !continueAsGuest,
        "hid-flex-jc-between": continueAsGuest,
      })}>
        { continueAsGuest && (
          <RPLButton
            className={styles.guestButton}
            onClick={() => handleGuestClick()}
            variant="secondary"
            label={t('CONTINUE_AS_GUEST_LABEL') as string}
          />
        )}
        
        <div className={styles.secondaryButtonWrapper}>
          {loginEnabled && (
            <Button onClick={() => handleLoginClick()} label={t('LOGIN') as string} />
          )}
          {createAccountEnabled && (
            <Button onClick={() => handleRegisterClick()} label={t('REGISTER') as string} />
          )}
        </div>
      </footer>
    </Modal>
  );
};

export default LoginFlowModal;
